import React, { FC } from 'react'
import styled from '@emotion/styled'
import Section from '../components/Section'
import SEO from '../components/SEO'
import Layout from '../components/Layout'
import Paginator from '../components/Navigation/Navigation.Paginator'
import ArticlesHero from '../sections/articles/Articles.Hero'
import ArticlesList from '../sections/articles/Articles.List'
import { graphql } from 'gatsby'
import { AllMarkdownRemarkI, PaginationContextI } from '../types/common'
import { SiteMetadataI, PostI, AuthorsI } from '../types/data-models'
interface ArticlesPageI {
  data: {
    site: {
      siteMetadata: SiteMetadataI
    }
    posts: AllMarkdownRemarkI<PostI>
    authors: AllMarkdownRemarkI<AuthorsI>
  }
  location: Location
  pageContext: PaginationContextI
}

const ArticlesPage: FC<ArticlesPageI> = ({ data, location, pageContext }) => {
  const articles = data.posts.nodes
  const authors = data.authors

  return (
    <Layout>
      <SEO pathname={location.pathname} />
      <ArticlesHero authors={authors} siteMetadata={data.site.siteMetadata} />
      <Section narrow>
        <ArticlesList articles={articles} />
        <ArticlesPaginator show={pageContext.totalPages > 1}>
          <Paginator {...pageContext} pathPrefix="/" />
        </ArticlesPaginator>
      </Section>
      <ArticlesGradient />
    </Layout>
  )
}

export default ArticlesPage

export const query = graphql`
  query($skip: Int!, $limit: Int!) {
    site {
      siteMetadata {
        title
        hero {
          heading
          maxWidth
        }
      }
    }
    posts: allMdx(
      filter: { fields: { type: { eq: "POST" } }, frontmatter: { isDraft: { eq: false } } }
      limit: $limit
      skip: $skip
    ) {
      nodes {
        excerpt
        timeToRead
        fields {
          slug
          type
        }
        frontmatter {
          title
          subtitle
          date
          coverImage {
            label
            url
          }
        }
      }
    }
    authors: allMdx(filter: { fields: { type: { eq: "AUTHOR" } } }) {
      nodes {
        fields {
          slug
          type
        }
        frontmatter {
          name
          bio
          avatar
          social {
            url
          }
          isFeatured
        }
      }
    }
  }
`

const ArticlesGradient = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 590px;
  z-index: 0;
  pointer-events: none;
  background: ${(p) => p.theme.colors.gradient};
  transition: ${(p) => p.theme.colorModeTransition};
`

const ArticlesPaginator = styled.div<{ show: boolean }>`
  ${(p) => p.show && `margin-top: 95px;`}
`
